import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';
import { ICON_MAP } from 'src/utils/constants';
import { PayStation } from 'src/features/payment/utils/types';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import ClearCashLevelsPayStationFormModal from 'src/features/payment/components/forms/ClearCashLevelsPayStationFormModal';
import ChangeCashLevels from 'src/features/payment/components/forms/ChangeCashLevels';
import CreatePayStationApiKeyFormModal from 'src/features/payment/components/CreatePayStationApiKeyFormModal';

type PayStationActionButtonsProps = {
    payStation: PayStation;
    acceptsCashPayments?: boolean;
    disabled?: boolean;
};
const PayStationActionButtons = ({ payStation, acceptsCashPayments, disabled = false }: PayStationActionButtonsProps) => {
    const { formatMessage } = useIntl();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="outline"
                    className="cursor-pointer hover:bg-transparent hover:text-inherit hover:shadow-none"
                >
                    <div>{formatMessage(paymentsMessages.actions)}</div>
                    <FontAwesomeIcon icon={ICON_MAP.ELLIPSIS} />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-full min-w-[200px]">
                <DropdownMenuLabel className="text-xs font-medium text-gray-600">
                    {formatMessage(paymentsMessages.payStationActions)}
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    <div className={disabled ? 'flex flex-col pointer-events-none opacity-50' : ''}>
                        <CreatePayStationApiKeyFormModal selectedPayStation={payStation}>
                            <div
                                className="relative flex cursor-pointer items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors">
                                {formatMessage(paymentsMessages.generateNewApiKey)}
                            </div>
                        </CreatePayStationApiKeyFormModal>
                        {acceptsCashPayments && (
                            <>
                                <ClearCashLevelsPayStationFormModal selectedPayStation={payStation} cashType="banknote">
                                    <div
                                        className="relative flex cursor-pointer items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors">
                                        {formatMessage(paymentsMessages.clearBanknoteLevels)}
                                    </div>
                                </ClearCashLevelsPayStationFormModal>
                                <ClearCashLevelsPayStationFormModal selectedPayStation={payStation} cashType="coin">
                                    <div
                                        className="relative flex cursor-pointer items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors">
                                        {formatMessage(paymentsMessages.clearCoinLevels)}
                                    </div>
                                </ClearCashLevelsPayStationFormModal>
                                <ChangeCashLevels selectedPayStation={payStation}>
                                    <div
                                        className="relative flex cursor-pointer items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors">
                                        {formatMessage(paymentsMessages.changeCoinBanknoteAvailability)}
                                    </div>
                                </ChangeCashLevels>
                            </>
                        )}
                    </div>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
);
};

export default PayStationActionButtons;
